import { cloneDeep } from 'lodash'
import ApiService from '@/core/services/api.service'
import ObjPath from 'object-path'
import ObjectPath from 'object-path'
import moment from 'moment-timezone'
import { toSafeNumber } from '@/core/plugins/math.lib'
import { ErrorEventBus, InitializeError } from '@/core/lib/message.lib'
import ManageSchedule from '@/core/plugins/leave.plugin'

// action types
export const SET_LEAVE_STATUS = 'SetLeaveStatus'
export const GET_LEAVE_STATUS = 'GetLeaveStatus'
/* export const GET_OPTION = "getVisitOption";
export const SET_OPTION = "setVisitOption"; */
export const SET_FILTER = 'setFilter'
export const SET_LOADING = 'setVisitLoading'
export const RESET_STATE = 'resetVisitState'
export const RESET_CREATE_STATE = 'resetVisitCreateState'
export const GET_RECURRING_LEAVE_DATE = 'GetRecurringLeaveDate'
export const SET_RAW_RECURRING_DATE = 'JtxJobSetRawRecurringDate'
export const UPDATE_SCHEDULE_STATE = 'JtxJobUpdateScheduleState'
export const SET_RECURRING_DATE = 'JtxJobSetRecurringDate'
export const UPDATE_DEFAULT_DATE = 'JtxJobUpdateDefaultDate'

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE)

const formatDate = date => {
  if (moment(date).isValid()) {
    return moment(date).format('DD MMMM YYYY hh:mm A')
  }
}
const todayDate = moment(new Date())
const adjustedStartTime = moment(todayDate)
  .startOf('hour')
  .add(Math.ceil(todayDate.minutes() / 60) * 60, 'minutes')
const adjustedStartEnd = moment(todayDate)
  .add(1, 'hour')
  .startOf('hour')
  .add(Math.ceil(todayDate.minutes() / 60) * 60, 'minutes')
const initialRecurringSchedule = {
  start_date: moment(todayDate).format('YYYY-MM-DD'),
  end_date: moment(todayDate).add(1, 'week').format('YYYY-MM-DD'),
  start_time: adjustedStartTime.format('hh:mm A'),
  end_time: adjustedStartEnd.format('hh:mm A')
}

const dbRecurringSchedule = {
  type: null,
  weeks: [],
  occurrence: 1,
  week_day: 1,
  week_count: 2,
  second_week_day: 5,
  second_week_count: 2,
  recurring_pattern: 1,
  message: null,
  existedLeave: [],
  end_mode: 2 /* occurrences = 2; end-date = 3 */,
  start_date: initialRecurringSchedule.start_date /* FORMAT - YYYY-MM-DD*/,
  end_date: initialRecurringSchedule.end_date /* FORMAT - YYYY-MM-DD*/,
  start_time: initialRecurringSchedule.start_time /* FORMAT - hh:mm A*/,
  end_time: initialRecurringSchedule.end_time /* FORMAT - hh:mm A*/
}
const dbDurationList = [
  { id: 1, short_name: '1st', long_name: 'First' },
  { id: 2, short_name: '2nd', long_name: 'Second' },
  { id: 3, short_name: '3rd', long_name: 'Third' },
  { id: 4, short_name: '4th', long_name: 'Fourth' },
  { id: 5, short_name: 'Last', long_name: 'Last' }
]
const initialSchedule = {
  start_date: moment(todayDate).format('YYYY-MM-DD'),
  end_date: moment(todayDate).format('YYYY-MM-DD')
}
const dbOneOffSchedule = {
  start_date: initialSchedule.start_date /* FORMAT - YYYY-MM-DD*/,
  end_date: initialSchedule.end_date /* FORMAT - YYYY-MM-DD*/
}
const dbRecurringScheduleTypeList = [
  { max_allowed: 0, group: 'daily', text: 'Daily', value: 'daily' },
  { max_allowed: 7, group: 'weekly', text: 'Weekly', value: 'weekly' },
  { max_allowed: 0, group: 'monthly', text: 'Monthly', value: 'monthly' }
]
export default {
  state: {
    db_leave_status: [],
    dbScheduleOutput: [],
    dbShowCalendar: false,
    db_leave_filter: {},
    dbRecurringSchedule: cloneDeep(dbRecurringSchedule),
    dbDurationList: cloneDeep(dbDurationList),
    dbOneOffSchedule: cloneDeep(dbOneOffSchedule),
    dbRecurringScheduleTypeList: cloneDeep(dbRecurringScheduleTypeList),

    db_option: {
      ticket_types: []
    },
    db_loading: false
  },

  getters: {
    getLeaveStatus (state) {
      return state.db_leave_status
    },
    getLeaveFilter (state) {
      return state.db_leave_filter
    },
    scheduleLeaveOutput (state) {
      return state.dbScheduleOutput
    },
    recurringSchedule (state) {
      return state.dbRecurringSchedule
    },
    durationList (state) {
      return state.dbDurationList
    },
    /*   vOption(state) {
      return state.db_option;
    }, */
    // recurringSchedule(state) {
    //   return state.dbRecurringSchedule;
    // },
    vShowCalendar (state) {
      return state.dbShowCalendar
    },
    leaveScheduleTypeList (state) {
      return state.dbRecurringScheduleTypeList
    }
  },
  actions: {
    GetRecurringLeaveDate (context) {
      context.commit(GET_RECURRING_LEAVE_DATE)
    },
    [RESET_STATE] (context) {
      context.commit(RESET_STATE)
    },
    [RESET_CREATE_STATE] (context) {
      context.commit(RESET_CREATE_STATE)
    },
    [GET_LEAVE_STATUS] (context, payload) {
      return new Promise((resolve, reject) => {
        context.commit(SET_LEAVE_STATUS, [])
        ApiService.setHeader()
        context.commit(SET_LOADING, true)
        ApiService.query('leave/status', payload)
          .then(response => {
            context.commit(
              SET_LEAVE_STATUS,
              ObjPath.get(response, 'data.data', [])
            )
            resolve(true)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            context.commit(SET_LOADING, false)
          })
      })
    },

    [SET_LOADING] (context, payload) {
      context.commit(SET_LOADING, payload)
    },
    [SET_FILTER] (context, payload) {
      context.commit(SET_FILTER, payload)
    },
    /* [GET_OPTION](context, request) {
      return new Promise((resolve, reject) => {
        ApiService.setHeader();
        context.commit(SET_LOADING, true);
        ApiService.query("job/options", {
          ...request,
          customer: toSafeInteger(context?.state?.db_customer?.id),
          billing: toSafeInteger(context?.state?.db_billing?.id),
          property: toSafeInteger(context?.state?.db_property?.id),
          property_person: toSafeInteger(
            context?.state?.db_property_contact?.id
          ),
          billing_person: toSafeInteger(context?.state?.db_billing_contact?.id),
        })
          .then((response) => {
            context.commit(SET_OPTION, ObjPath.get(response, "data.data", {}));
            resolve(true);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            context.commit(SET_LOADING, false);
          });
      });
    }, */
    [GET_RECURRING_LEAVE_DATE] (context) {
      const recurringSchedule = context.state.dbRecurringSchedule
      const validScheduleType = ['weekly', 'date_range', 'monthly']
      if (!validScheduleType.includes(recurringSchedule?.type)) {
        return false
      }
       if (
        recurringSchedule.occurrence == 0 ||
        recurringSchedule.occurrence == ''
      ) {
        ErrorEventBus.$emit(
          'update:error',
          InitializeError('Occurrence Should be greater then 0.')
        )
        return false
      }

      const resetLeaveSchedule = () => {
        context.commit(UPDATE_SCHEDULE_STATE, {
          key: 'dbLeaveSchedule.message',
          value: null
        })
        context.commit(UPDATE_SCHEDULE_STATE, {
          key: 'dbLeaveSchedule.end_date',
          value: recurringSchedule.end_date
        })
        context.commit(SET_RECURRING_DATE, [])
        context.commit(SET_RAW_RECURRING_DATE, [])
      }

      const startDate = moment(
        `${recurringSchedule.start_date} ${recurringSchedule.start_time}`
      ).format('YYYY-MM-DD HH:mm:ss')

      const occurrences = toSafeNumber(recurringSchedule.occurrence, 10)
      if (occurrences > 365) {
        ErrorEventBus.$emit(
          'update:error',
          InitializeError('Occurrence cannot be greater then 365.')
        )
        return false
      }
      const endDate =
        recurringSchedule.end_mode == 3
          ? moment(
              `${recurringSchedule.end_date} ${recurringSchedule.end_time}`
            ).format('YYYY-MM-DD HH:mm:ss')
          : null
      const selectedDays = recurringSchedule.weeks

      const pattern = toSafeNumber(recurringSchedule.recurring_pattern, 1)
      const endMode = toSafeNumber(recurringSchedule.end_mode, 2)
      const weekDay = toSafeNumber(recurringSchedule.week_day, -1)
      const weekCount = toSafeNumber(recurringSchedule.week_count, -1)
      const existedLeave = recurringSchedule.existedLeave
      const scheduleManager = new ManageSchedule(
        startDate,
        occurrences,
        endDate,
        endMode,
        pattern,
        weekDay,
        existedLeave,
        weekCount
      )

      let scheduleDate = []
      // if (recurringSchedule?.type == "daily") {
      //   scheduleDate = scheduleManager.generateDailySchedule();
      // }
      if (recurringSchedule?.type == 'date_range') {
        scheduleDate = scheduleManager.generateDailySchedule(
          recurringSchedule.existedLeave
        )
      }

      if (recurringSchedule?.type == 'weekly') {
        if (recurringSchedule?.weeks?.length < 1) {
          resetLeaveSchedule()
          ErrorEventBus.$emit(
            'update:error',
            InitializeError('Please Select Weeks for the leave schedule.')
          )
          return false
        }
        scheduleDate = scheduleManager.generateWeeklySchedule(
          1,
          selectedDays.slice(0, 7),
          occurrences,
          recurringSchedule.existedLeave
        )
      }
      if (recurringSchedule?.type == 'monthly') {
        scheduleDate = scheduleManager.generateMonthlySchedule(
          1,
          occurrences,
          endDate,
          recurringSchedule,
          recurringSchedule.existedLeave
        )
      }

      if (!scheduleDate.length) {
        resetLeaveSchedule()
        ErrorEventBus.$emit(
          'update:error',
          InitializeError('Oops... Dates are not available.')
        )
        return false
      }

      const scheduleStartDate = scheduleDate[0]
      const scheduleEndDate = new Date(scheduleDate[scheduleDate.length - 1])

      const endTime = moment(
        `${recurringSchedule.start_date} ${recurringSchedule.end_time}`
      ).format('HH:mm:ss')

      let [hour, minute, second] = endTime.split(':')

      scheduleEndDate.setHours(hour)
      scheduleEndDate.setMinutes(minute)
      scheduleEndDate.setSeconds(second)

      const message = String(scheduleManager.message)
        .replace('{TYPE}', recurringSchedule?.type?.text)
        .replace('{START_DATE_TIME}', formatDate(scheduleStartDate))
        .replace('{OCCURRENCE}', scheduleDate.length)
        .replace('{END_DATE_TIME}', formatDate(scheduleEndDate))
      context.commit(UPDATE_SCHEDULE_STATE, {
        key: 'dbLeaveSchedule.message',
        value: message
      })

      const combineDate = scheduleManager.combineDate(scheduleDate, endTime)

      context.commit(SET_RECURRING_DATE, combineDate)
      context.commit(SET_RAW_RECURRING_DATE, combineDate)
      return true
    },
    [UPDATE_DEFAULT_DATE] (context, payload) {
      let startedAt = null
      let finishedAt = null
      if (payload == 'leave') {
        startedAt = `${context.state.dbRecurringSchedule.start_date} ${context.state.dbRecurringSchedule.start_time}`
        finishedAt = `${context.state.dbRecurringSchedule.end_date} ${context.state.dbRecurringSchedule.end_time}`
      }
      context.commit(UPDATE_DEFAULT_DATE, { startedAt, finishedAt })
    }
  },
  mutations: {
    [UPDATE_DEFAULT_DATE] (state, { startedAt, finishedAt }) {
      state.dbDefaultStartedAt = startedAt
        ? moment(startedAt).format('YYYY-MM-DD HH:mm')
        : null
      state.dbDefaultFinishedAt = finishedAt
        ? moment(finishedAt).format('YYYY-MM-DD HH:mm')
        : null
    },
    [SET_RAW_RECURRING_DATE] (state, payload) {
      state.dbRawScheduleOutput = cloneDeep(payload)
    },
    [RESET_CREATE_STATE] (state) {
      state.db_leave_status = []
      state.db_leave_filter = {}
      state.db_loading = false
    },
    [RESET_STATE] (state) {
      state.db_leave_status = []
      state.db_leave_filter = {}
      state.db_loading = false
    },

    [SET_LOADING] (state, payload) {
      state.db_loading = payload
    },
    [SET_FILTER] (state, payload) {
      state.db_leave_filter = cloneDeep(payload)
    },
    [SET_LEAVE_STATUS] (state, payload) {
      state.db_leave_status = cloneDeep(payload)
    },
    [UPDATE_SCHEDULE_STATE] (state, { key, value }) {
      ObjectPath.set(state, key, cloneDeep(value))
    },

    [SET_RECURRING_DATE] (state, payload) {
      state.dbScheduleOutput = cloneDeep(payload)
    }
    // [UPDATE_SCHEDULE_STATE](state, { key, value }) {
    //   ObjectPath.set(state, key, cloneDeep(value));
    // },
  }
}
